<div class="product-questions">
      <h3 class="title-h3">{{'Dúvidas Frequentes' | translate}}</h3>
      <div class="content">
          <div class="item" *ngFor="let d of data">
              <div class="item-header" (click)="_click(d)">
                  <div class="title">
                      <i class="material-icons">help</i>
                      <span>{{d.titulo}}</span>
                  </div>
                  <div class="icon">
                      <i class="material-icons" *ngIf="!d.show">expand_more</i>
                      <i class="material-icons" *ngIf="d.show">expand_less</i>
                  </div>    
              </div>
              <div class="item-content animated slideInDown" *ngIf="d.show">  
                  <article [innerHtml]="d.texto | safeHtml"></article>    
              </div>   
          </div>    
      </div>    
  </div>
  